
export class BrowseImageComponentText {
    maxImageSizeError: string = 'File size may not exceed (1MB)';
    sizeErrorMsgHeading: string = 'File Size Error';
    typeErrorMsgHeading: string = 'File Type Error';
    imageTypeError: string = 'Unsupported file type';
}
